var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.as,{tag:"div",staticClass:"Box",class:[
    _vm.visuallyHidden && 'visuallyHidden',
    _vm.printHidden && 'printHidden',
    _vm.as === 'ul' && 'listReset',
  ],style:(_vm.styles)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }